import { RoleService } from "@js/services/RoleService";
import {
  ALItemTypeEnum,
  ALTypeEnum,
  AddressLookupDTO,
  AssetLiabilityItem,
  AssetLiabilityItemClient,
  Case,
  CaseClient,
  CaseMember,
  CaseMemberClient,
  StreetAddressClient,
  QualificationsClient,
  Qualifications,
  ProjectOwnership,
  PostalAddress,
  CaseCrudClient,
  CaseMemberCrudClient,
  AssetLiabilityItemInsert,
  AssetLiabilityItemCrudClient,
} from "@src/apis/ModularClient";
import { AddressHistoryDTO } from "@js/DTO/AddressHistoryDTO.cs";
import { Expand } from "@ccq/ts-lib";
import { ODataHelper } from "@js/helpers/ODataHelper";

export class ApplicantDetailsController {
  //navigate for pages
  step: number = 1;
  applicantNo: number = 0;
  devexperienceId: number;

  //current case
  case: Expand<Case, { readonly developmentInput: true }>;
  caseTitle: string;

  //current shareholder
  currentShareholder: Expand<CaseMember, { readonly assetLiabilityItems: true; readonly qualifications: true }>;

  //case id
  caseid: number;

  development: ProjectOwnership;
  developmentTrackRecordType: {}[] = [];

  //qualifications
  newQualification: string[] = [];
  newSkill: string[] = [];
  duplicate: number[] = [];

  //address
  previousAddressSearchTerm: string;
  searchingForPreviousAddress: boolean = false;
  previousAddressPostCodeOptions: AddressLookupDTO[] = [];
  showAddHistoryConfirmDelete: boolean = false;
  addressHistoryIdToDelete: number;
  showAddressHistoryModal: boolean = false;
  shareholderAddressHistory: AddressHistoryDTO[] = [];
  addressHistoryItem: AddressHistoryDTO;
  previousAddressSearchResults: string[];
  searchpostcode: string[];
  searchterm: string[];
  searchresults: string[];
  PostCodeOptions: AddressLookupDTO[][] = [];
  searchingForAddress: boolean = false;

  error: boolean = false;
  saving: boolean = false;
  dataLoading: boolean = false;
  saved: boolean = false;

  //modal
  message: string = "";
  modal: boolean = false;
  openModal: boolean = false;

  //to edit input on A&L
  newDescription: string;
  newValue: number;
  newStartDate: Date;
  newEndDate: Date;
  ALItemType: ALItemTypeEnum;
  item: AssetLiabilityItem;
  applicant: CaseMember;
  renamingItem: AssetLiabilityItem;
  confirmationDelete: boolean = false;

  //validation dates
  maxDateOfBirth: Date = new Date();
  minDateOfBirth: Date = new Date("Jan 01 1900");
  maxDateForDateField: Date = new Date("Jan 01 3000");
  isAddFormInvalid: boolean = true;
  isEditFormInvalid: boolean = true;

  //forms
  multiPartForm1: ng.IFormController;
  multiPartForm2: ng.IFormController;
  multiPartForm3: ng.IFormController;
  multiPartForm4: ng.IFormController;
  multiPartForm7: ng.IFormController;

  formattedAcquisitionDate: any[] = [];

  YearsWorkedInProfessionsListArchitectCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListBuilderCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListCarpenterCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListElectricianCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListEstateAgencyCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListPlannerCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListProjectManagerCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListPropertySurveyorCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListQuantitySurveyorCheckbox: boolean[] = [];
  YearsWorkedInProfessionsListStructuralEngineerCheckbox: boolean[] = [];

  professionsList: string[] = [
    "Architect",
    "Builder",
    "Carpenter",
    "Electrician",
    "EstateAgency",
    "Planner",
    "ProjectManager",
    "PropertySurveyor",
    "QuantitySurveyor",
    "StructuralEngineer",
  ];

  applicantDetailsFormSectionNames = [
    {
      label: "Applicant Details",
      visible: true,
    },
  ];

  asset = {};

  static $inject = [
    "$routeParams",
    "$q",
    "$rootScope",
    "$location",
    "RoleService",
    "CaseMemberClient",
    "AssetLiabilityItemClient",
    "AssetLiabilityItemCrudClient",
    "CaseClient",
    "StreetAddressClient",
    "QualificationsClient",
    "CaseCrudClient",
    "CaseMemberCrudClient",
    "ODataHelper",
  ];

  constructor(
    private $routeParams: ng.route.IRouteParamsService,
    protected $q: ng.IQService,
    private $rootScope: ng.IRootScopeService,
    private $location: ng.ILocationService,
    private roleService: RoleService,
    private caseMemberClient: CaseMemberClient,
    private assetLiabilityItemClient: AssetLiabilityItemClient,
    private assetLiabilityItemCrudClient: AssetLiabilityItemCrudClient,
    private caseClient: CaseClient,
    private streetAddressClient: StreetAddressClient,
    private qualificationsClient: QualificationsClient,
    private caseCrudClient: CaseCrudClient,
    private caseMemberCrudClient: CaseMemberCrudClient,
    private odataHelper: ODataHelper,
  ) {
    this.onInit();
  }

  onInit() {
    //Get step number
    if (this.$routeParams.StepNumber) {
      this.step =
        this.$routeParams.StepNumber > 8 || this.$routeParams.StepNumber < 1 ? 1 : this.$routeParams.StepNumber;
    }

    if (this.$routeParams.CaseId) {
      this.caseid = this.$routeParams.CaseId;

      this.odataHelper
        .getOne(this.caseCrudClient, {
          filter: {
            id: {
              eq: Number(this.$routeParams.CaseId),
            },
          },
          expand: {
            developmentInput: true,
          },
        })
        .then((result) => {
          this.case = result;
          this.caseTitle = result.developmentInput.searchName;
        });
    }

    if (this.$routeParams.shareholderId) {
      this.applicantNo = this.$routeParams.shareholderId;

      this.odataHelper
        .getOne(this.caseMemberCrudClient, {
          filter: {
            id: {
              eq: Number(this.applicantNo),
            },
          },
          expand: {
            assetLiabilityItems: {
              filter: {
                isDeleted: {
                  eq: false,
                },
              },
            },
            qualifications: true,
          },
        })
        .then((result) => {
          this.currentShareholder = result;
          if (this.currentShareholder.addressHistory && this.currentShareholder.addressHistory.length > 0) {
            this.parseAddressHistory(this.currentShareholder.addressHistory);
          }
        });
    }

    if (this.$routeParams.Id && this.$routeParams.Id > 0) {
      this.devexperienceId = this.$routeParams.Id;
    }
  }

  goToCaseDashboard(blockSave?: boolean): void {
    if (this.roleService.IsLender == true) {
      this.$location.path("/casedashboard/" + this.caseid);
    } else {
      if (blockSave) {
        this.save(true).then((response) => {
          this.$location.path("/casedashboard/" + this.caseid);
          (this.$rootScope as any).formSaved = true;
        });
      } else {
        this.save(false).then(() => {
          this.$location.path("/casedashboard/" + this.caseid);
        });
      }
    }
  }

  goToShareholders(blockSave?: boolean): void {
    if (this.roleService.IsLender == true) {
      this.$location.path("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/2");
    } else {
      if (blockSave) {
        this.save(true).then((response) => {
          this.$location.path("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/2");
          (this.$rootScope as any).formSaved = true;
        });
      } else {
        this.save(false).then(() => {
          this.$location.path("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/2");
        });
      }
    }
  }

  //save
  save(isFormComplete: boolean): ng.IPromise<number> {
    let defer = this.$q.defer<number>();

    this.saving = true;
    const { qualifications, assetLiabilityItems, ...onlyCurrentShareholder } = this.currentShareholder;

    this.caseMemberClient
      .addUpdateCustom(onlyCurrentShareholder)
      .then((response) => {
        this.setAllFormsPristine();
        defer.resolve(response.id);
        return response;
      })
      .catch((response) => {
        defer.reject(response);
        this.error = true;
      })
      .finally(() => {
        this.saving = false;
      });

    return defer.promise;
  }

  //resent forms
  setAllFormsPristine(): void {
    if (this.multiPartForm1) {
      this.multiPartForm1.$setPristine();
    }
    if (this.multiPartForm2) {
      this.multiPartForm2.$setPristine();
    }
    if (this.multiPartForm3) {
      this.multiPartForm3.$setPristine();
    }
    if (this.multiPartForm4) {
      this.multiPartForm4.$setPristine();
    }
    if (this.multiPartForm7) {
      this.multiPartForm7.$setPristine();
    }
  }

  //Navigate for tabs

  navigateTabs(index: number) {
    this.profileGo(
      "/applicantdetails/" +
        this.caseid +
        "/" +
        this.devexperienceId +
        "/" +
        this.applicantNo +
        "/" +
        this.sum(index, 1),
    );
    (this.$rootScope as any).formSaved = true;
  }

  sum(a: number, b: number): number {
    return a + b;
  }

  go(path): void {
    // Only need to save if user is NOT a lender (everything is in read-only mode for lender)
    if (this.roleService.IsLender == true) {
      this.$location.path(path);
    } else {
      this.save(false).then((response) => {
        this.devexperienceId = response;
        this.$location.path(path);
      });
    }
  }

  profileGo(path): void {
    if (this.roleService.IsLender == true) {
      this.$location.path(path);
    } else {
      this.save(false).then((response) => {
        this.$location.path(path);
      });
    }
  }

  next(): void {
    if (this.step == 1 && this.step < 2) {
      this.step++;
      this.profileGo(
        "/applicantdetails/" +
          this.caseid +
          "/" +
          this.devexperienceId +
          "/" +
          this.$routeParams.shareholderId +
          "/" +
          this.step,
      );
      (this.$rootScope as any).formSaved = true;
    }
  }

  backApplicantDetails(): void {
    if (this.step >= 1 && this.step < 3) {
      this.step--;
      this.profileGo(
        "/applicantdetails/" +
          this.caseid +
          "/" +
          this.devexperienceId +
          "/" +
          this.$routeParams.shareholderId +
          "/" +
          this.step,
      );
      (this.$rootScope as any).formSaved = true;
    }
  }

  updateProfessionsCheckboxes(applicant: CaseMember, index: number): boolean {
    if (applicant) {
      this.professionsList.forEach((p) => {
        if (applicant["yearsWorkedInProfessionsList" + p] > 0) {
          this["YearsWorkedInProfessionsList" + p + "Checkbox"][index] = true;
        }
      });
      return true;
    } else {
      return false;
    }
  }

  finish(): void {
    this.$location.path("/devexperience/" + this.caseid + "/" + this.devexperienceId + "/2");
    (this.$rootScope as any).formSaved = true;
  }

  addAssetLiabilityItem(
    currentApplicant: Expand<CaseMember, { readonly assetLiabilityItems: true; readonly qualifications: true }>,
    ALTtype: ALTypeEnum,
    AlTItem: ALItemTypeEnum,
    description,
    value: number,
    startDate = null,
    endDate = null,
  ) {
    const newAssetLiabilityItem: AssetLiabilityItem = {
      alType: ALTtype,
      alItemType: AlTItem,
      description: description,
      value: value === null || value === undefined ? 0 : value,
      startDate: startDate,
      endDate: endDate,
      caseMemberId: currentApplicant.id,
      caseMember: null,
      id: 0,
      isDeleted: false,
      createdDateTime: null,
      lastUpdatedDateTime: null,
      lastModifiedUser: null,
      lastModifiedUserId: null,
      createdUserId: null,
      createdUser: null,
    };

    this.assetLiabilityItemClient
      .addUpdate(newAssetLiabilityItem)
      .then((response) => {
        this.currentShareholder.assetLiabilityItems.push(response);
        this.asset = {};
      })
      .catch((error) => {
        this.error = true;
      })
      .finally(() => {
        delete this.asset;
      });
  }

  //Calculations

  CalculateTotalAssets(currentApplicant: CaseMember): number {
    var totalAssets: number = 0;
    if (currentApplicant && currentApplicant.assetLiabilityItems) {
      for (let i = 0; i < currentApplicant.assetLiabilityItems.length; i++) {
        if (currentApplicant.assetLiabilityItems[i].alType === ALTypeEnum.Asset) {
          totalAssets += Number(currentApplicant.assetLiabilityItems[i].value);
        }
      }
    }
    return totalAssets;
  }

  CalculateTotalLiabilities(currentApplicant: CaseMember): number {
    var totalLiabilities: number = 0;
    if (currentApplicant && currentApplicant.assetLiabilityItems) {
      for (let i = 0; i < currentApplicant.assetLiabilityItems.length; i++) {
        if (currentApplicant.assetLiabilityItems[i].alType === ALTypeEnum.Liability) {
          totalLiabilities += Number(currentApplicant.assetLiabilityItems[i].value);
        }
      }
    }
    return totalLiabilities;
  }

  CalculateTotalOutstandingPersonalGuarantees(currentApplicant: CaseMember): number {
    var totalPersonalGuarantees: number = 0;
    if (currentApplicant && currentApplicant.assetLiabilityItems) {
      for (let i = 0; i < currentApplicant.assetLiabilityItems.length; i++) {
        if (currentApplicant.assetLiabilityItems[i].alType === ALTypeEnum.PersonalGuarantee) {
          totalPersonalGuarantees += Number(currentApplicant.assetLiabilityItems[i].value);
        }
      }
    }
    return totalPersonalGuarantees;
  }

  CalculateTotalNetAssets(currentApplicant: CaseMember): number {
    var totalNetAssets: number;

    if (currentApplicant && currentApplicant.assetLiabilityItems) {
      totalNetAssets = this.CalculateTotalAssets(currentApplicant) - this.CalculateTotalLiabilities(currentApplicant);
    }
    return totalNetAssets;
  }

  cancelDelete() {
    this.confirmationDelete = false;
  }

  deleteConfirmationMessage(applicant: CaseMember, item: AssetLiabilityItem) {
    this.item = item;
    this.applicant = applicant;
    this.confirmationDelete = true;
  }

  removeAssetLiabilityItem() {
    this.confirmationDelete = false;
    const index = this.applicant.assetLiabilityItems.indexOf(this.item);
    this.applicant.assetLiabilityItems.splice(index, 1);
  }

  renameItem(item: AssetLiabilityItem) {
    this.ALItemType = item.alItemType;
    this.newDescription = item.description;
    this.newValue = item.value;
    this.newStartDate = item.startDate;
    this.newEndDate = item.endDate;

    if (this.renamingItem === undefined) {
      this.renamingItem = item;
    } else {
      delete this.renamingItem;
    }
  }

  renamingItemComplete(currentApplicant: CaseMember, item: AssetLiabilityItem, index: number) {
    this.assetLiabilityItemCrudClient
      .patch(item)
      .then((response) => {
        this.currentShareholder.assetLiabilityItems = this.currentShareholder.assetLiabilityItems.map((item) =>
          item.id === response.id ? response : item,
        );
        this.asset = {};
      })
      .catch((error) => {
        this.error = true;
      })
      .finally(() => {});

    delete this.renamingItem;
  }

  cancelSaveItem(item: AssetLiabilityItem, index: number) {
    item.alItemType = this.ALItemType;
    item.description = this.newDescription;
    item.value = this.newValue;
    item.startDate = this.newStartDate;
    item.endDate = this.newEndDate;
    delete this.renamingItem;
  }

  showprofession(enumVal: number) {
    if (this.currentShareholder) {
      return (
        this.currentShareholder.developedPropertyBefore &&
        (this.currentShareholder.professionsWorkedIn & enumVal) == enumVal
      );
    } else {
      return false;
    }
  }

  resetDuplicateMessage(index: number) {
    this.duplicate[index] = 0;
  }

  addQualification(currentApplicant: CaseMember, index, isQualification, qualificationOrSkill) {
    this.saving = true;
    if (currentApplicant.qualifications === null || !currentApplicant.qualifications) {
      currentApplicant.qualifications = [];
    }
    if (
      !currentApplicant.qualifications.find(
        (x) => x.qualificationOrSkill === qualificationOrSkill || x.qualificationOrSkill === qualificationOrSkill,
      )
    ) {
      const qual: Qualifications = {
        caseMember: null,
        createdDateTime: null,
        createdUser: null,
        createdUserId: null,
        lastModifiedUser: null,
        lastModifiedUserId: null,
        lastUpdatedDateTime: null,
        caseMemberId: currentApplicant.id,
        qualificationOrSkill: qualificationOrSkill,
        isQualification: isQualification,
        id: 0,
        isDeleted: false,
      };
      currentApplicant.qualifications.push(qual);

      this.qualificationsClient
        .addUpdateListReturnOnlyID(currentApplicant.qualifications)
        .then((response) => {
          //update IDs
          currentApplicant.qualifications.forEach((x, index) => {
            x.id = response[index];
          });
        })
        .catch((error) => {
          this.error = true;
        })
        .finally(() => {
          delete this.newQualification[index];
          delete this.newSkill[index];
          this.saving = false;
        });
    } else {
      //Qualification already present
      if (isQualification) {
        //Qual entered already on list
        this.duplicate[index] = 1;
      } else {
        //Skill entered already on list
        this.duplicate[index] = 2;
      }
      this.saving = false;
      delete this.newQualification[index];
      delete this.newSkill[index];
    }
  }

  removeSkillOrQualification(currentApplicant: CaseMember, item: Qualifications) {
    const index = currentApplicant.qualifications.indexOf(item);
    currentApplicant.qualifications.splice(index, 1);
  }

  getALItemType(item: AssetLiabilityItem) {
    let ALItemTypeValue = "";
    switch (item.alItemType) {
      case ALItemTypeEnum.Other: {
        ALItemTypeValue = "Other";
        break;
      }
      case ALItemTypeEnum.ResidentialProperty: {
        ALItemTypeValue = "Residential Property";
        break;
      }
      case ALItemTypeEnum.OverseasProperty: {
        ALItemTypeValue = "Overseas Property";
        break;
      }
      case ALItemTypeEnum.BTLProperty: {
        ALItemTypeValue = "BTL Property";
        break;
      }
      case ALItemTypeEnum.CommercialProperty: {
        ALItemTypeValue = "Commercial Property";
        break;
      }
      case ALItemTypeEnum.ArtJewellryAntique: {
        ALItemTypeValue = "Art Jewellry Antique";
        break;
      }
      case ALItemTypeEnum.CashDeposits: {
        ALItemTypeValue = "Cash / Deposits";
        break;
      }
      case ALItemTypeEnum.StocksShares: {
        ALItemTypeValue = "Stocks & Shares";
        break;
      }
      case ALItemTypeEnum.VehicleBoat: {
        ALItemTypeValue = "Vehicle / Boats";
        break;
      }
      case 8: {
        ALItemTypeValue = "Business Equipment / Plant & Machinery";
        break;
      }
      case 9: {
        ALItemTypeValue = "Art / Jewellery / Antiques";
        break;
      }
      case ALItemTypeEnum.ResidentialPropertyLoan: {
        ALItemTypeValue = "Residential Property Loan";
        break;
      }
      case ALItemTypeEnum.OverseasPropertyLoan: {
        ALItemTypeValue = "Overseas Property Loan";
        break;
      }
      case ALItemTypeEnum.BTLPropertyLoan: {
        ALItemTypeValue = "BTL Property Loan";
        break;
      }
      case ALItemTypeEnum.CommercialPropertyLoan: {
        ALItemTypeValue = "Commercial Property Loan";
        break;
      }
      case ALItemTypeEnum.Overdraft: {
        ALItemTypeValue = "Overdraft";
        break;
      }
      case ALItemTypeEnum.HPLease: {
        ALItemTypeValue = "HP / Leasing";
        break;
      }
      case ALItemTypeEnum.Overdraft: {
        ALItemTypeValue = "HP / Leasing";
        break;
      }
      case 35: {
        ALItemTypeValue = "Overdraft";
        break;
      }
      case 36: {
        ALItemTypeValue = "Other Bank / Finance Loans";
        break;
      }
      case ALItemTypeEnum.PersonalGuarantee: {
        ALItemTypeValue = "Outstanding Personal Guarantee";
        break;
      }

      default: {
        ALItemTypeValue = "Unknown";
        break;
      }
    }
    return ALItemTypeValue;
  }

  proprtyTypeFilter(property) {
    if (property.alType == ALTypeEnum.Asset) {
      return (
        property.alItemType == ALItemTypeEnum.ResidentialProperty ||
        property.alItemType == ALItemTypeEnum.OverseasProperty ||
        property.alItemType == ALItemTypeEnum.BTLProperty ||
        property.alItemType == ALItemTypeEnum.CommercialProperty
      );
    }
  }

  otherProprtyTypeFilter(property: AssetLiabilityItem) {
    if (property.alType == ALTypeEnum.Asset) {
      return (
        property.alItemType == ALItemTypeEnum.CashDeposits ||
        property.alItemType == ALItemTypeEnum.StocksShares ||
        property.alItemType == ALItemTypeEnum.VehicleBoat ||
        property.alItemType == ALItemTypeEnum.BusinessEquipment ||
        property.alItemType == ALItemTypeEnum.ArtJewellryAntique ||
        property.alItemType == ALItemTypeEnum.Other
      );
    }
  }

  liabilitiesFilter(property) {
    if (property.alType == ALTypeEnum.Liability) {
      return (
        property.alItemType == ALItemTypeEnum.ResidentialPropertyLoan ||
        property.alItemType == ALItemTypeEnum.OverseasPropertyLoan ||
        property.alItemType == ALItemTypeEnum.BTLPropertyLoan ||
        property.alItemType == ALItemTypeEnum.CommercialPropertyLoan
      );
    }
  }

  otherliabilitiesFilter(property) {
    if (property.alType == ALTypeEnum.Liability) {
      return (
        property.alItemType == ALItemTypeEnum.HPLease ||
        property.alItemType == ALItemTypeEnum.Overdraft ||
        property.alItemType == ALItemTypeEnum.OtherLoan ||
        property.alItemType == ALItemTypeEnum.Other
      );
    }
  }

  isInvalidForm(description: string, value: number, startDate: Date, endDate: Date, prefix: string) {
    if (!description || !value) {
      return true;
    }

    const validStartDate = document.getElementById(prefix + "-startDate").className.search("ng-valid");
    const validEndDate = document.getElementById(prefix + "-endDate").className.search("ng-valid");

    if (validStartDate < 0 || validEndDate < 0) {
      return true;
    }

    if (startDate && !this.isValidDate(startDate)) {
      return true;
    }

    if (endDate && !this.isValidDate(endDate)) {
      return true;
    }

    return false;
  }

  isAddFormValid(description: string, value: number, startDate: Date, endDate: Date) {
    this.isAddFormInvalid = this.isInvalidForm(description, value, startDate, endDate, "add");
  }

  isEditFormValid(description: string, value: number, startDate: Date, endDate: Date) {
    this.isEditFormInvalid = this.isInvalidForm(description, value, startDate, endDate, "edit");
  }

  isValidDate(date: Date) {
    if (date.getFullYear() > 1900 && date.getFullYear() < 2900) {
      return true;
    }
    return false;
  }

  /**
   * Save a new PostAddress history item
   * @param shareholder
   */
  saveAddressHistory(shareholder: CaseMember) {
    var id: number = 0;

    if (!this.shareholderAddressHistory) {
      this.shareholderAddressHistory = [];
    }

    // If the Id hasn't been set then this is a new previous address
    if (this.addressHistoryItem.Id == null) {
      id = this.getNextAddressHistoryId();
      this.addressHistoryItem.Id = id;
      this.shareholderAddressHistory.push(this.addressHistoryItem);
    } else {
      var foundIndex = this.shareholderAddressHistory
        .map(function (a) {
          return a.Id;
        })
        .indexOf(this.addressHistoryItem.Id);
      if (foundIndex > -1) {
        this.shareholderAddressHistory.splice(foundIndex, 1, this.addressHistoryItem); // removed previous entry and adds the updated one in its place
      }
    }

    this.caseMemberClient
      .saveAddressHistory(shareholder.id, JSON.stringify(this.shareholderAddressHistory))
      .then((addressHistory: string) => {
        shareholder.addressHistory = addressHistory;
        this.parseAddressHistory(addressHistory);
        this.showAddressHistoryModal = false;
      })
      .catch((error) => {
        this.modal = true;
        this.message = "There was a problem saving the address history. Please try again later.";
      })
      .finally(() => {
        this.showAddressHistoryModal = false;
      });
  }

  getNextAddressHistoryId(): number {
    if (this.shareholderAddressHistory.length == 0) {
      return 1;
    } else {
      // Get the current maximum Id and add one to it for the next ID
      var id = Math.max.apply(
        Math,
        this.shareholderAddressHistory.map(function (a) {
          return a.Id;
        }),
      );
      id++;
      return id;
    }
  }

  /**
   * Convert addres history JSON back to an array of PostalAddress objects
   * @param addressHistoryJson
   */
  parseAddressHistory(addressHistoryJson: string) {
    // JSON doesn't understand date types so therefore user the reviver function to manually convert them back to dates as opposed to strings
    this.shareholderAddressHistory = JSON.parse(addressHistoryJson, this.reviver);

    // Order the address histories by the from date (ascending)
    this.shareholderAddressHistory.sort((a: AddressHistoryDTO, b: AddressHistoryDTO) => {
      return this.getTime(a.FromDate) - this.getTime(b.FromDate);
    });
  }

  getTime(date?: Date) {
    return date != null ? date.getTime() : 0;
  }

  /**
   * Tests whether a string is a date and converts it if so - used in JSON.parse
   * @param key
   * @param value
   */
  reviver(key, value) {
    var a;
    if ((typeof value === "string" && key == "ToDate") || key == "FromDate") {
      a = Date.parse(value);
      if (a) {
        return new Date(a);
      }
    }
    return value;
  }

  getAddressAsString(address: PostalAddress) {
    var addressAsString: string = "";

    addressAsString = this.concatenateAddressLine(address.addressLine1, addressAsString);
    addressAsString = this.concatenateAddressLine(address.addressLine2, addressAsString);
    addressAsString = this.concatenateAddressLine(address.addressLine3, addressAsString);
    addressAsString = this.concatenateAddressLine(address.addressLine4, addressAsString);

    return addressAsString;
  }

  concatenateAddressLine(addressLine: string, concatenatedAddress: string) {
    if (addressLine != null && addressLine.length > 0) {
      if (concatenatedAddress.length > 0) {
        concatenatedAddress = concatenatedAddress.concat(", ", addressLine);
      } else {
        concatenatedAddress = concatenatedAddress.concat(addressLine);
      }
    }

    return concatenatedAddress;
  }

  openAddressHistoryModal(addressHistory: AddressHistoryDTO = null) {
    this.previousAddressSearchResults = [];
    this.previousAddressPostCodeOptions = [];

    if (addressHistory) {
      this.addressHistoryItem = addressHistory;
    } else {
      this.addressHistoryItem = null;
    }

    this.showAddressHistoryModal = true;
  }

  showConfirmAddressDelete(addressHistoryId: number) {
    this.showAddHistoryConfirmDelete = true;
    this.addressHistoryIdToDelete = addressHistoryId;
  }

  deleteAddressHistory() {
    this.showAddHistoryConfirmDelete = false;

    var foundIndex = this.shareholderAddressHistory
      .map(function (a) {
        return a.Id;
      })
      .indexOf(this.addressHistoryIdToDelete);

    if (foundIndex > -1) {
      this.shareholderAddressHistory.splice(foundIndex, 1);

      this.caseMemberClient
        .saveAddressHistory(this.currentShareholder.id, JSON.stringify(this.shareholderAddressHistory))
        .then((addressHistory: string) => {
          this.currentShareholder.addressHistory = addressHistory;
          this.parseAddressHistory(addressHistory);
          this.showAddressHistoryModal = false;
        })
        .catch((error) => {
          this.modal = true;
          this.message = "There was a problem deleting the address history item. Please try again later.";
        });
    }
  }

  formatDate(unformattedDate) {
    if (unformattedDate) {
      var formattedDate = new Date(unformattedDate.getTime() - unformattedDate.getTimezoneOffset() * 60000)
        .toISOString()
        .split("T")[0];

      return formattedDate;
    }
  }

  getAddressList(app: CaseMember, index: number, searchTerm: string) {
    let foundMatch = false;

    if (this.PostCodeOptions && this.PostCodeOptions[index] && this.PostCodeOptions[index].length > 0) {
      let addressLookup = this.PostCodeOptions[index].find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          this.currentShareholder.postalAddress = address;
          this.searchterm[index] = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.currentShareholder.postalAddress.addressLine1 = addressLookup.addressLine2;
        this.currentShareholder.postalAddress.addressLine2 = addressLookup.addressLine3;
        this.currentShareholder.postalAddress.addressLine3 = addressLookup.addressLine4;
        this.currentShareholder.postalAddress.addressLine4 = addressLookup.postCode;
        this.currentShareholder.postalAddress.postCode = addressLookup.addressLine1;
        this.searchterm[index] = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.PostCodeOptions[index] = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.PostCodeOptions[index] = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  getAddressListArray(app: CaseMember, index: number, searchTerm: string) {
    let foundMatch = false;

    if (this.PostCodeOptions && this.PostCodeOptions[index] && this.PostCodeOptions[index].length > 0) {
      let addressLookup = this.PostCodeOptions[index].find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          app.postalAddress = address;
          this.searchterm[index] = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.development.developmentTrackRecords[index].postalAddress.addressLine1 = addressLookup.addressLine2;
        this.development.developmentTrackRecords[index].postalAddress.addressLine2 = addressLookup.addressLine3;
        this.development.developmentTrackRecords[index].postalAddress.addressLine3 = addressLookup.addressLine4;
        this.development.developmentTrackRecords[index].postalAddress.addressLine4 = addressLookup.postCode;
        this.development.developmentTrackRecords[index].postalAddress.postCode = addressLookup.addressLine1;
        this.searchterm[index] = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.PostCodeOptions[index] = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.PostCodeOptions[index] = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  lookupPreviousAddress(searchTerm: string) {
    let foundMatch = false;

    if (this.previousAddressPostCodeOptions != null && this.previousAddressPostCodeOptions.length > 0) {
      let addressLookup = this.previousAddressPostCodeOptions.find((add) => {
        return add.addressLine1 + " " + add.addressLine2 === searchTerm;
      });

      if (addressLookup && !(addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;

        // We've selected an address!
        this.streetAddressClient.getFullAddress((addressLookup as AddressLookupDTO).id).then((address) => {
          this.addressHistoryItem = {
            addressLine1: address.addressLine1,
            addressLine2: address.addressLine2,
            addressLine3: address.addressLine3,
            addressLine4: address.addressLine4,
            postCode: address.postCode,
          };

          this.previousAddressSearchTerm = "";
        });
      } else if (addressLookup && (addressLookup as AddressLookupDTO).isPostCode) {
        foundMatch = true;
        this.addressHistoryItem = {
          addressLine1: addressLookup.addressLine2,
          addressLine2: addressLookup.addressLine3,
          addressLine3: addressLookup.addressLine4,
          addressLine4: addressLookup.postCode,
          postCode: addressLookup.addressLine1,
        };

        this.previousAddressSearchTerm = "";
      }
    }

    if (searchTerm.length >= 3 && !foundMatch) {
      this.searchingForAddress = true;
      // Initial search term
      this.previousAddressPostCodeOptions = [];

      this.streetAddressClient
        .getAddressList(searchTerm)
        .then((response) => {
          this.previousAddressPostCodeOptions = response;
        })
        .finally(() => {
          this.searchingForAddress = false;
        });
    }
  }

  autofillShareholderInfo() {
    this.currentShareholder.developedPropertyBefore = true;
    this.currentShareholder.lengthOfTimeBeenDeveloper = 10;
    this.currentShareholder.developedPropertyBeforeNumber = 7;
    this.currentShareholder.developedResidentialPropertyCompletedNumber = 7;
    // this.YearsWorkedInProfessionsListProjectManagerCheckbox[1] = true;
    this.currentShareholder.yearsWorkedInProfessionsListProjectManager = 7;
    this.addAssetLiabilityItem(
      this.currentShareholder,
      ALTypeEnum.Asset,
      ALItemTypeEnum.ResidentialProperty,
      "32 Brookside Road",
      900000,
      null,
      null,
    );
    this.addAssetLiabilityItem(
      this.currentShareholder,
      ALTypeEnum.Asset,
      ALItemTypeEnum.BTLProperty,
      "10 Brookside Road",
      100000,
      null,
      null,
    );
    this.addAssetLiabilityItem(
      this.currentShareholder,
      ALTypeEnum.Asset,
      ALItemTypeEnum.CommercialProperty,
      "King Street, York",
      2300000,
      null,
      null,
    );
    this.addAssetLiabilityItem(
      this.currentShareholder,
      ALTypeEnum.Asset,
      ALItemTypeEnum.CashDeposits,
      "Savings",
      1000000,
      null,
      null,
    );
    this.addAssetLiabilityItem(
      this.currentShareholder,
      ALTypeEnum.Asset,
      ALItemTypeEnum.StocksShares,
      "Barclays Bank",
      450000,
      null,
      null,
    );
    this.addAssetLiabilityItem(
      this.currentShareholder,
      ALTypeEnum.Liability,
      ALItemTypeEnum.ResidentialPropertyLoan,
      "32 Brookside",
      450000,
      null,
      null,
    );
    const maxDate = Date.now();
    const timestamp = Math.floor(Math.random() * maxDate);
    const timestamp2 = timestamp + 20;
    this.addAssetLiabilityItem(
      this.currentShareholder,
      2,
      60,
      "Example lender",
      400000,
      new Date(timestamp),
      new Date(timestamp2),
    );
  }
}
